<template>
  <div
    class="narrator-calendar-btn"
    @mouseenter="onHover=true"
    @mouseleave="onHover=false"
  >
    <IButton
      id="IStagingCalendarBtn"
      class="btn-ghost flex-wrap"
      :class="{ active: isCalendarActive || onHover }"
      @click="showCalendar"
    >
      <i class="isif isif-calendar" />
    </IButton>
    <div
      class="narrator-calendar-tip"
      :class="[onHover ? 'hover' : '']"
    >
      <span>{{ $t('booking.reserve') }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import IButton from '../../../IButton'

export default {
  name: 'CalendarBtn',

  components: {
    IButton
  },

  data () {
    return {
      onHover: false,
      isActive: false
    }
  },

  computed: {
    ...mapGetters([
      'isCalendarActive'
    ])
  },

  methods: {
    showCalendar () {
      this.$emit('showCalendar')
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main'

.narrator-calendar-btn {
  position: relative;
  font-size: 1rem;
  cursor: pointer;
  margin-top : 16px;
  width: 40px;
  height: 40px;
  background-color: alpha($dark-gray, 80%);
  border-radius: 50%;

  & .active {
    color: $pink-color;
  }

  @media (min-width: $response) {
    width: 48px;
    height: 48px;
  }

  &, button {
    display: flex;
    align-items: center;
    color: white;
  }

  button {
    width: 100%;
    height: 100%;
    padding: 0;
    font-size: inherit;

    i {
      font-size: 1.5em;

      @media (min-width: $response) {
        font-size: 1.75em;
      }
    }
  }

  .narrator-calendar-tip {
    position: absolute;
    right : 140%;
    top: 50%;
    opacity: 0;
    display: inline-block;
    white-space: nowrap;
    transform: translateY(-50%);
    line-height: 1.6
    transition: all .1s linear;
    pointer-events: none;
    z-index: 10

    &.hover {
      opacity: 1;
    }

    span {
      text-shadow: none;
      font-size: 0.9rem;
      padding: 4px;
      background-color: alpha($dark-gray, 80%);

      &::after {
        position: absolute;
        content: "";
        left: 100%;
        top: 0;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 12px;
        border-color: transparent transparent transparent alpha($dark-gray, 80%);
      }
    }
  }
}
</style>
